import { Action, createReducer, on } from '@ngrx/store';
import { fromNotificationTypesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { INotificationTypesResponse } from '../models/notification-types.model';
import * as actions from '../actions';

export const notificationTypesFeatureKey = 'notificationTypes';

export interface NotificationTypeState {
  loadNotificationTypeResponse: INotificationTypesResponse[];
  loadNotificationTypeFailure: Error | any;
}

export const initialState: NotificationTypeState = {
  loadNotificationTypeResponse: undefined,
  loadNotificationTypeFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadNotificationTypesSuccess, (state, action) => ({
    ...state,
    loadNotificationTypeResponse: action.response
  }))
);

export const getNotificationTypes = (state: NotificationTypeState) => state.loadNotificationTypeResponse;
